import { FC } from 'react'
import styled from 'styled-components'
import { formatJSONDate } from 'yancey-js-util'
import { PostLite } from 'src/types'

const NextAndPrevLink = styled.a`
  display: block;
  margin-bottom: 10px;
  font-size: 12px;
  color: #233;
  &:hover {
    color: #c30;
  }
`

interface Props {
  next: PostLite | null
  prev: PostLite | null
}

const NextAndPrev: FC<Props> = ({ next, prev }) => {
  return (
    <div>
      {prev && (
        <NextAndPrevLink href={`/post/${prev._id}`}>
          上一篇: {prev.title} [{formatJSONDate(prev.createdAt).split(' ')[0]}]
        </NextAndPrevLink>
      )}

      {next && (
        <NextAndPrevLink href={`/post/${next._id}`}>
          下一篇: {next.title} [{formatJSONDate(next.createdAt).split(' ')[0]}]
        </NextAndPrevLink>
      )}
    </div>
  )
}

export default NextAndPrev
